export function stringSort(property: string) {
  return (a: Record<string, string>, b: Record<string, string>): number => {
    const stringA = a[property].toUpperCase()
    const stringB = b[property].toUpperCase()
    let comparison = 0

    if (stringA > stringB) {
      comparison = 1
    } else if (stringA < stringB) {
      comparison = -1
    }
    return comparison
  }
}
